export interface ChecklistItem {
  id: string;
  question: string;
}

export interface ChecklistBlock {
  id: string;
  title: string;
  items: ChecklistItem[];
}

export const CHECKLIST_BLOCKS: ChecklistBlock[] = [
  {
    id: 'situacion-pruebas',
    title: 'Bloque 1: SITUACIÓN DE PRUEBAS',
    items: [
      { id: '1.1', question: '¿Se ha informado a la CRA sobre el inicio de las pruebas?' },
      { id: '1.2', question: '¿Se ha obtenido el registro de las incidencias del sistema de los últimos 15 días?' },
      { id: '1.3', question: '¿Se ha obtenido otro registro de incidencias al finalizar las pruebas?' },
      { id: '1.4', question: '¿Se ha comprobado con la CRA que todas las señales de alarma han llegado a destino?' },
    ],
  },
  {
    id: 'alimentacion-sistema',
    title: 'Bloque 2: ALIMENTACIÓN DEL SISTEMA',
    items: [
      { id: '2.1', question: 'Verificar tensión de las salidas auxiliares (13,8V CA, 12V batería).' },
      { id: '2.2', question: 'Provocar un fallo de red de CA.' },
      { id: '2.3', question: 'Provocar un fallo de batería.' },
    ],
  },
  {
    id: 'central-intrusion',
    title: 'Bloque 3: CENTRAL DE INTRUSIÓN',
    items: [
      { id: '3.1', question: 'Verificar tamper y estado físico de la caja.' },
      { id: '3.2', question: 'Verificar conexiones internas y estado general.' },
    ],
  },
  {
    id: 'teclados',
    title: 'Bloque 4: TECLADOS',
    items: [
      { id: '4.1', question: 'Comprobar posibles fallos con el usuario.' },
      { id: '4.2', question: 'Verificar display, teclas, leds y zumbador.' },
      { id: '4.3', question: 'Verificar tamper del teclado.' },
    ],
  },
  {
    id: 'detectores',
    title: 'Bloque 5: DETECTORES',
    items: [
      { id: '5.1', question: 'Verificar activación y cobertura (volumétricos, contactos, pulsadores).' },
      { id: '5.2', question: 'Verificar que la distribución del mobiliario no afecte la cobertura.' },
      { id: '5.3', question: 'Verificar activación del tamper y transmisión a CRA.' },
      { id: '5.4', question: 'Verificar que las señales lleguen a CRA.' },
    ],
  },
  {
    id: 'comunicaciones',
    title: 'Bloque 6: COMUNICACIONES',
    items: [
      { id: '6.1', question: 'Verificar envío de eventos a CRA.' },
      { id: '6.2', question: 'Verificar envío por ambas vías (si existen dos).' },
      { id: '6.3', question: 'Verificar acceso bidireccional.' },
    ],
  },
  {
    id: 'cctv',
    title: 'Bloque 7: CCTV',
    items: [
      { id: '7.1', question: 'Estado físico y limpieza de cámaras.' },
      { id: '7.2', question: 'Estado físico y limpieza del grabador.' },
      { id: '7.3', question: 'Verificar que almacena imágenes correctamente.' },
      { id: '7.4', question: 'Verificar visualización día/noche mediante grabaciones.' },
      { id: '7.5', question: 'Verificar hora correcta del grabador.' },
      { id: '7.6', question: 'Verificar acceso remoto por internet.' },
    ],
  },
];
